export default __webpack_public_path__ + "static/media/MP5_2.24f4fadb.png";